<template>
  <div class="documentationContainer">
    <h1 class="documentationContainer__title large-title">
      {{title}}
    </h1>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'adx-documentation-container',
  props: {
    title: { required: true }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>